

import React, { useState } from "react";

import EvaHealthSafetyBriefing from "./EvaHealthSafetyBriefing";
import EvaQuestionnaire from "./EvaQuestionnaire";
import EvaDocumentDrawer from "./EvaDocumentDrawer";

import "./EvaDemoToolbar.css";


//========================================================
// EVA Demo Presenter Toolbar
//========================================================

const CHAIR_VIDEO_ID = "bU-QfbDCEDE";

const DEMO_LINKS = [
    { id: "chair", label: "Chair Instructions" },
    { id: "briefing", label: "Briefing" },
    { id: "questionnaire", label: "Questionnaire" },
	{ id: "presentation", label: "Presentation" },
	  { id: "document", label: "Document Pop-up" }
];


//========================================================
// Component
//========================================================

export default function EvaDemoToolbar() {

    const [activeDemo, setActiveDemo] = useState(null);

    //----------------------------------------------------
    // Close
    //----------------------------------------------------

    const closeDemo = () => {
        setActiveDemo(null);
    };

    //----------------------------------------------------
    // Active Label
    //----------------------------------------------------

    const activeLabel =
        DEMO_LINKS.find(
            link => link.id === activeDemo
        )?.label;

    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (
        <>

            {/*===============================================
              Presenter Toolbar
            ===============================================*/}

            <div className="eva-presenter-toolbar">

                {DEMO_LINKS.map((link, index) => (

                    <React.Fragment key={link.id}>

                        {index > 0 && (

                            <span className="eva-presenter-separator">
                                |
                            </span>

                        )}

                        <button
                            type="button"
                            className="eva-presenter-link"
                            onClick={() => setActiveDemo(link.id)}
                        >
                            {link.label}
                        </button>

                    </React.Fragment>

                ))}

            </div>

            {/*===============================================
              Health & Safety Briefing
            ===============================================*/}

            {activeDemo === "briefing" && (

                <EvaHealthSafetyBriefing
                    onClose={closeDemo}
                />

            )}

            {/*===============================================
              Interactive Questionnaire
            ===============================================*/}

            {activeDemo === "questionnaire" && (

                <EvaQuestionnaire
                    onClose={closeDemo}
                />

            )}
			
			
			{/*===============================================
			  Document Library
			===============================================*/}

			{activeDemo === "document" && (

			    <EvaDocumentDrawer
			        onClose={closeDemo}
			    />

			)}

            {/*===============================================
              Other Demonstration Popups
            ===============================================*/}

			{activeDemo &&
			    activeDemo !== "briefing" &&
			    activeDemo !== "questionnaire" &&
			    activeDemo !== "document" && (

                <div
                    className="eva-presenter-overlay"
                    onClick={closeDemo}
                >

                    <div
                        className="eva-presenter-popup"
                        onClick={event =>
                            event.stopPropagation()
                        }
                    >

                        <div className="eva-presenter-popup-header">

                            <strong>
                                {activeLabel}
                            </strong>

                            <button
                                type="button"
                                onClick={closeDemo}
                                aria-label="Close demonstration"
                            >
                                ×
                            </button>

                        </div>

                        <div className="eva-presenter-popup-body">

						{activeDemo === "chair" ? (

						    <iframe
						        title="Chair Adjustment Instructions"
						        src={
						            "https://www.youtube-nocookie.com/embed/" +
						            CHAIR_VIDEO_ID +
						            "?autoplay=1&rel=0"
						        }
						        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						        allowFullScreen
						    />

						) : activeDemo === "presentation" ? (

						    <iframe
						        title="OmniScan Presentation"
						        src={
						            process.env.PUBLIC_URL +
						            "/website/html/specialscreens/how-it-works.html"
						        }
						        className="eva-presenter-presentation-frame"
						        allowFullScreen
						    />

						) : (

						    <div className="eva-presenter-placeholder">
						        Demonstration content coming next.
						    </div>

						)}

                        </div>

                    </div>

                </div>

            )}

        </>
    );

}
